import React, { useEffect, useRef, useState } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import "../App.css";
import LeftSidebar from "./LeftSidebar";

import createImage from "./functions/createImage";
import createText from "./functions/createText";
import selectElement from "./functions/selectElement";
import createGrids from "./functions/createGrids";
import importData from "./functions/importData";
import axios from "axios";

import saveCurrentWorkState from "./functions/saveCurrentWorkState";
import importPrevWorkState from "./functions/importPrevWorkState";
import { getNestedList } from "./helper";
import { CustomSelect, DownloadSelect } from "./CustomSelect";
import { FaHamburger, FaRegSave } from "react-icons/fa";
import { TbFileDownload } from "react-icons/tb";
import { IoClose, IoMenu } from "react-icons/io5";

import {
  Modal,
  Box,
  Typography,
  Button,
  Divider,
  Link,
  IconButton,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "#1e293b", // slate-800
  color: "#f8fafc", // slate-50
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  fontFamily: "Poppins, sans-serif",
  fontWeight: "400",
};

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#131B25",
    color: "FFFFFF",
    maxWidth: 220,
    fontSize: "1rem",
    border: "1px solid #28394E",
  },
}));

const numOfRows = 13;

const vocals = [
  "Vocal",
  "Guitar",
  "Bass",
  "Keys",
  "Horn",
  "Percussion",
  "Kick",
  "Snare",
  "Hi-Hat",
  "Ride",
  "Crash",
  "Tom",
  "Overhead",
  "Media Player",
];

const vocalMics = [
  "Vocal Mic",
  "Amp Mic",
  "Guitar Mic",
  "Drum Mic",
  "DI XLR",
  "DI 1/4",
];

const tableStyles = {
  tableContainer: {
    width: "100%",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#1C2938",
    borderRight: "1px solid #28394E",
  },
  th: {
    padding: "0.1rem",
    fontWeight: "normal",
    fontSize: "14px",
    color: "#a0aec0",
    backgroundColor: "#1C2938",
    borderBottom: "1px solid #28394E",
  },
  td: {
    padding: "0.1rem",
    color: "#a0aec0",
    borderBottom: "1px solid #28394E",
    cursor: "pointer",
  },
};

const StageBuilder = () => {
  //*************************** User Level */
  const [isPremium, setIsPremium] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [openWatermarkModal, setOpenWatermarkModal] = useState(false);

  //*************************** title */
  const [title, setTitle] = useState("");
  const [imageList, setImageList] = useState([]);
  const [dropCount, setDropCount] = useState(0);
  const titleRef = useRef(null);

  //*************************** title */
  const [subscriptionLevel, setSubscriptionLevel] = useState(null);

  useEffect(() => {
  const handleResize = () => {
    console.log("Window resized:", window.innerWidth);
    setIsSidebarOpen(true)
  };

  window.addEventListener("resize", handleResize);

  // Run once immediately if needed
  handleResize();

  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);

  useEffect(() => {
    const level = new URLSearchParams(window.location.search).get("subs");
    setSubscriptionLevel(Number(level));
  }, []);
  //*************************** drag and drop */
  const imageRef = useRef(null);
  const stageRef = useRef(null);
  const designAreaRef = useRef(null);

  useEffect(() => {
    const checkPremiumStatus = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/session-info`
        );
        if (res.data?.isPremium) {
          setIsPremium(true);
        }
      } catch (err) {
        console.error("Failed to check premium status:", err);
      }
    };

    checkPremiumStatus();
  }, []);

  useEffect(() => {
    const imageListRes = getNestedList();
    setImageList(imageListRes);
  }, []);

  const handleDrop = (e) => {
    if (imageRef.current === null) return;

    const rect = stageRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left; // X position relative to the component
    const y = e.clientY - rect.top; // Y position relative to the component

    if (imageRef.current === "textLabel") {
      createText({ x: x, y: y }, designAreaRef.current);
    } else {
      createImage(
        { x: x, y: y, image: imageRef.current },
        designAreaRef.current
      );
    }

    setDropCount((prev) => prev + 1);

    imageRef.current = null;
  };

  const cancelSelected = () => {
    const imageElement = document.querySelector(".delete-mark");
    document.getElementById("add-input-button").innerText = "Add Input";
    indexOfArray.current = null;
    if (imageElement === null) return;
    if (imageElement.classList.contains("selected")) {
      imageElement.classList.remove("selected");
    }
    imageElement.classList.remove("delete-mark");
  };
  //*************************** drag and drop */

  //*************************** table */
  let indexOfArray = useRef(null);

  const [entries, setEntries] = useState([]);
  const [name, setName] = useState("");
  const [type, setType] = useState("Vocal");
  const [input, setInput] = useState("Vocal Mic");

  const grids = createGrids(entries);

  const handleTableRow = (e, index, i) => {
    e.stopPropagation();
    indexOfArray.current = index * numOfRows + i;

    const row = entries[indexOfArray.current];
    if (!!row === false) {
      cancelSelected();
      return;
    }

    const element = document.getElementById(`tr-${indexOfArray.current}`);
    selectElement(element);

    setName(row.name);
    setType(row.type);
    setInput(row.input);
  };

  const addEntry = () => {
    if (document.getElementById("add-input-button").innerText === "Add Input") {
      if (name && type && input) {
        const newEntries = [...entries];
        newEntries.push({
          name,
          type,
          input,
        });
        setEntries(newEntries);

        // setName("Gary");
        setName("");
        setType(type);
        setInput(input);
      }
    } else {
      const newEntries = [...entries];
      newEntries[indexOfArray.current] = { name, type, input };
      setEntries(newEntries);
      document.getElementById("add-input-button").innerText = "Add Input";
    }
  };

  const deleteEntry = () => {
    if (indexOfArray.current === null) return;
    const newEntries = [...entries];
    delete newEntries[indexOfArray.current];
    setEntries(newEntries.filter((a) => a != null));

    cancelSelected();
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Delete" || e.key === "Backspace") {
        deleteEntry();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [entries]);
  //*************************** table */

  document.addEventListener("keydown", (e) => {
    if (e.key === "Delete") {
      const element = document.querySelector(".delete-mark");

      if (element === null) return;

      if (element.id.includes("tr-")) return;

      indexOfArray.current = null;
      element.remove();
    }
  });

  //*************************** data import */
  const [jsonData, setJsonData] = useState(null);

  useEffect(() => {
    if (jsonData === null) return;
    importPrevWorkState(jsonData, imageList, designAreaRef.current);
    setEntries(jsonData.entries);
    setTitle(jsonData.title);
  }, [jsonData]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0]; // Get the first selected file

    if (file && file.type === "application/json") {
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const data = JSON.parse(e.target.result); // Parse the JSON data
          setJsonData(data);
        } catch (error) {
          alert("Invalid JSON file!");
        }
      };

      reader.onerror = () => {
        alert("Error reading file");
      };

      reader.readAsText(file);
    } else {
      alert("Please select a valid JSON file");
    }
  };
  //*************************** data import */

  return (
    <div className="position-relative">
      <span
        style={{
          top: 15,
          left: 20,
          zIndex: 9999,
          position: "absolute",
        }}
      >
        <button
          className=""
          onClick={() => setIsSidebarOpen(true)}
          style={{
            all: "unset",
            cursor: "pointer",
          }}
        >
          <IoMenu size={30} color="#008281" />
        </button>
      </span>

      <img
        src="/music.svg"
        style={{ position: "absolute", top: 20, right: 40, zIndex: 9999 }}
        alt="favicon"
      />

      <div className="d-flex pt-1 text-center flex-column flex-md-row">
        <div
          className="sidebar"
          style={{
            width: isSidebarOpen ? "250px" : "0",
            // position: isSidebarOpen ? "fixed" : "relative",
            overflowX: "hidden",
            transition: "0.3s",
          }}
          // style={{
          //   width: "100%",
          //   backgroundColor: "#1C2938",
          //   color: "white",
          //   zIndex: 999999,
          //   flex: "0 0 20%",
          // }}
        >
          <LeftSidebar
            iRef={imageRef}
            imageList={imageList}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            height: "700px",
            marginLeft: "250px",
          }}
          id="stage-container"
          className={`ml-custom-0`}
        >
          <div
            style={{
              flex: "1",
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
            }}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
            ref={stageRef}
            onClick={cancelSelected}
          >
            <div
              id="stage"
              ref={designAreaRef}
              style={{
                flex: 1,
                position: "relative",
                // overflow: "auto",
              }}
            >
              {!isPremium ? <WaterMark /> : null}

              <div
                id="title"
                ref={titleRef}
                contentEditable
                suppressContentEditableWarning={true}
                style={{ border: "none", outline: "none" }}
                className="editable-div"
              >
                {title}
              </div>
            </div>

            {dropCount === 0 && jsonData === null && (
              <div
                className="rounded flex dragAndDrop"
                style={{
                  flex: 1,
                  position: "absolute",
                  top: "20%",
                  left: "50%",
                  height: "30%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "70vw",
                  transform: "translate(-50%, -20%)",
                }}
              >
                <p
                  style={{
                    fontSize: "32px",
                    maxWidth: "300px",
                    color: "#8D949B",
                    opacity: "70%",
                  }}
                >
                  Drag items from sidebar here
                </p>
              </div>
            )}

            <div
              style={{
                backgroundColor: "#1C2938",
                color: "white",
              }}
              id="input-table"
              className="d-flex align-items-end"
            >
              <div className="w-100 d-flex">
                {grids &&
                  grids.map((grid, index) => (
                    <table
                      key={index}
                      id={`table-${index}`}
                      style={tableStyles.table}
                      className="m-0"
                    >
                      <thead>
                        {grid.length > 0 && (
                          <tr
                            style={{
                              fontSize: "12px",
                            }}
                            className=""
                          >
                            <th style={tableStyles.th}>NO</th>
                            <th style={tableStyles.th}>NAME</th>
                            <th style={tableStyles.th}>TYPE</th>
                            <th style={tableStyles.th}>INPUT</th>
                          </tr>
                        )}
                      </thead>
                      <tbody>
                        {grid.map((entry, i) => (
                          <tr
                            key={i}
                            id={`tr-${index * numOfRows + i}`}
                            onClick={(e) => handleTableRow(e, index, i)}
                            style={{
                              "&:hover": {
                                backgroundColor: "#008281",
                              },
                            }}
                          >
                            {entry !== null ? (
                              <>
                                <td style={tableStyles.td}>
                                  {i + index * 10 + 1}
                                </td>
                                <td style={tableStyles.td}>{entry.name}</td>
                                <td style={tableStyles.td}>{entry.type}</td>
                                <td style={tableStyles.td}>{entry.input}</td>
                              </>
                            ) : (
                              <>
                                <td style={tableStyles.td}>
                                  {" "}
                                  {i + index * 10 + 1}{" "}
                                </td>
                                <td style={tableStyles.td}> - </td>
                                <td style={tableStyles.td}> - </td>
                                <td style={tableStyles.td}> - </td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ))}
              </div>
              {subscriptionLevel === 1 && <WaterMark />}
            </div>
          </div>

          <div
            style={{
              position: "fixed",
              bottom: 0,
              backgroundColor: "#1C2938",
              color: "white",
              padding: "0.85rem 12px",
              gap: "10px",
            }}
            id="control-area"
            className="d-flex flex-column flex-xl-row control-area justify-content-xl-between align-items-xl-center input-download-group"
          >
            <div
              className="d-flex  flex-column flex-sm-row justify-content-xl-center align-items-xl-center"
              style={{
                gap: "5px",
              }}
              id="table-controllers"
            >
              <input
                type="text"
                placeholder="Name"
                className="p-2 responsive-input w-100 w-sm-auto custom-max-w"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                  backgroundColor: "#131B25",
                  border: "1px solid #28394E",
                  borderRadius: "8px",
                  color: "white",
                
                }}
              />

              <CustomSelect
                value={type}
                onChange={(e) => setType(e.target.value)}
                options={vocals}
                className="w-100 w-sm-auto"
              />

              <CustomSelect
                value={input}
                onChange={(e) => setInput(e.target.value)}
                options={vocalMics}
                className="w-100 w-sm-auto"
              />

              <button
                id={"add-input-button"}
                type="submit"
                onClick={addEntry}
                className="rounded p-2 flex-shrink-1"
                style={{
                  backgroundColor: "#008281",
                  cursor: "pointer",
                  color: "white",
                  border: "1px solid #28394E",
                }}
              >
                Add Input
              </button>
            </div>

            <div className="d-flex flex-column gap-4">
              {!isPremium && (
                <button
                  className="rounded p-2 mb-1"
                  style={{
                    backgroundColor: "#008281",
                    cursor: "pointer",
                    color: "white",
                    border: "1px solid #28394E",
                    maxWidth: "200px",
                  }}
                  onClick={() => setOpenWatermarkModal(true)}
                >
                  Remove Watermark
                </button>
              )}

              <div
                className="d-flex justify-content-xl-center align-items-xl-center"
                id="stage-controllers"
                style={{
                  gap: "5px",
                }}
              >
                <CustomTooltip title="Import Design">
                  <button
                    className="rounded pt-1"
                    style={{
                      backgroundColor: "#008281",
                      cursor: isPremium ? "pointer" : "auto",
                      color: "white",
                      border: "1px solid #28394E",
                      opacity: isPremium ? 1 : 0.6,
                    }}
                    onClick={
                      isPremium ? importData : () => setOpenWatermarkModal(true)
                    }
                  >
                    <TbFileDownload
                      style={{
                        fontSize: "28px",
                      }}
                    />
                  </button>
                </CustomTooltip>

                <input
                  id="file-input"
                  type="file"
                  accept=".json"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                />
                <CustomTooltip title="Save Design">
                  <button
                    className="rounded pt-1"
                    style={{
                      backgroundColor: "#008281",
                      cursor: isPremium ? "pointer" : "auto",
                      color: "white",
                      border: "1px solid #28394E",
                      opacity: isPremium ? 1 : 0.6,
                    }}
                    onClick={
                      isPremium
                        ? () => saveCurrentWorkState(entries)
                        : () => setOpenWatermarkModal(true)
                    }
                  >
                    <FaRegSave
                      style={{
                        fontSize: "28px",
                      }}
                    />
                  </button>
                </CustomTooltip>

                <DownloadSelect
                  stageRef={stageRef}
                  subscriptionLevel={subscriptionLevel}
                  isPremium={isPremium}
                  setOpenWatermarkModal={setOpenWatermarkModal}
                />
              </div>
            </div>

            {openWatermarkModal ? (
              <RemoveWatermarkModal
                open={openWatermarkModal}
                onClose={() => setOpenWatermarkModal(false)}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const WaterMark = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          fontSize: "10rem",
          color: "gray",
          transform: "rotate(-45deg)",
          opacity: 0.2,
        }}
      >
        BandBreeze
      </div>
      <div
        style={{
          fontSize: "10rem",
          color: "gray",
          transform: "rotate(-45deg)",
          opacity: 0.2,
          marginTop: "10rem",
        }}
      >
        BandBreeze
      </div>
      <div
        style={{
          fontSize: "10rem",
          color: "gray",
          transform: "rotate(-45deg)",
          opacity: 0.2,
          marginTop: "10rem",
        }}
      >
        BandBreeze
      </div>
    </div>
  );
};

const RemoveWatermarkModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8, color: "#94a3b8" }}
        >
          <IoClose size={22} />
        </IconButton>

        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: "#f1f5f9", fontFamily: "Poppins, sans-serif" }}
        >
          Upgrade Your Plan
        </Typography>

        <Typography
          variant="body1"
          gutterBottom
          sx={{ color: "#cbd5e1", fontFamily: "Poppins, sans-serif" }}
        >
          To remove the watermark and enable downloads, please log in to your
          account and upgrade your plan.
        </Typography>

        <Button
          variant="contained"
          fullWidth
          href="https://www.mybandbreeze.com/login"
          rel="noopener noreferrer"
          sx={{
            fontFamily: "Poppins, sans-serif",
            mt: 2,
            bgcolor: "#3b82f6",
            "&:hover": { bgcolor: "#3b82f6" },
          }}
        >
          Login
        </Button>

        <Divider sx={{ my: 3, borderColor: "#334155" }} />

        <Typography
          variant="body2"
          align="center"
          sx={{
            color: "#94a3b8",
            fontFamily: "Poppins, sans-serif",
            fontSize: "0.90rem",
          }}
        >
          New here?{" "}
          <Link
            href="https://www.mybandbreeze.com/signup"
            target="_blank"
            underline="hover"
            sx={{ color: "#4ade80" }}
          >
            Create an account
          </Link>{" "}
          or{" "}
          <Link
            href="https://www.bandbreeze.com/pricing"
            target="_blank"
            underline="hover"
            sx={{ color: "#60a5fa" }}
          >
            view pricing plans
          </Link>
          .
        </Typography>
      </Box>
    </Modal>
  );
};

export default StageBuilder;
